import React from 'react'
import Link from 'gatsby-link'

import PrSquare from '../images/prlaw-square.jpg'
// import PrWide from '../images/prlaw-wide.jpg'
import PrForm from '../files/prlaw-form.pdf'

import Layout from '../components/layout'

const PrestonPage = () => (
  <Layout>
    <article className="cf ph3 ph5-ns pt5">
      <div className="fn fl-ns w-40-ns pr4-ns">
        <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
          Preston Russell Law Award
        </h1>
        <h2 className="f4 mid-gray lh-title">
        <a href={PrForm} target="_blank" rel="noopener noreferrer">Download</a> the form or <Link className="fw7 link dim turquoise" to="/preston-application" title="Volunteer Application">apply online</Link> 
        <br/>
        </h2>
        <div className="mt3">
            <img src={PrSquare} alt="Preston Russell Law Award Logo"/>
        </div>
      </div>
      <div className="fn fl-ns w-60-ns">
        <p className="measure mt0-ns">
            Preston Russell Law sponsor the Preston Russell Law Art Awards at the Riverton Community Arts Centre.
        </p>
        <p className="measure">
        The awards are open to artists living in Southland and Otago and to Friends (members) of the Riverton Community Art Centre.
        </p>
        <p className="measure">
        The cost of entry is $25.00 and only one entry can be sent.  The supreme winner receives $2000.00 from Preston Russell Law and three other artists receive $300.00 each for the judges choice award.  
        </p>
        <p className="measure">
        This is a significant award and offers an opportunity to emerging and established artists to participate. 
        </p>
      </div>
    </article>
  </Layout>
)

export default PrestonPage
